import React, { useRef } from 'react';
import { Pressable } from 'react-native';
import { useHover, useFocus, useActive } from 'react-native-web-hooks';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Colors from '../colors';
import Icon from '../icon';
import Spacer from '../spacer';
import Text from '../text';
const StyledView = styled.View`
 display: flex;
 flex-direction: row;
`;
export default function RadioButton(props) {
  const ref = useRef();
  const hovered = useHover(ref);
  const focused = useFocus(ref);
  const activated = useActive(ref);
  const highlighted = hovered || focused || activated;
  return /*#__PURE__*/React.createElement(Pressable, {
    onPress: props === null || props === void 0 ? void 0 : props.onPress,
    disabled: props.disabled
  }, /*#__PURE__*/React.createElement(StyledView, null, /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    name: props.checked ? 'radio-button-checked' : 'radio-button-unchecked',
    size: 24,
    color: highlighted ? Colors.mint400 : props.checked ? Colors.mint500 : Colors.lightGray400
  }), /*#__PURE__*/React.createElement(Spacer, {
    width: 12
  }), /*#__PURE__*/React.createElement(Text, {
    color: props.disabled ? Colors.lightGray400 : Colors.Gray600
  }, props.label)));
}
RadioButton.propTypes = {
  checked: PropTypes.bool,
  onPress: PropTypes.func,
  label: PropTypes.string,
  disabled: PropTypes.bool
};
RadioButton.defaultProps = {
  checked: false,
  onPress: () => {},
  label: '',
  disabled: false
};
//# sourceMappingURL=radio-button.js.map